// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation } from 'swiper'
Swiper.use([Navigation])

document.addEventListener('DOMContentLoaded', () => {
  const teasers = document.querySelectorAll('.a-teaser-slider-two-column')

  teasers.forEach((teaser) => {
    const slider = teaser.querySelector('.swiper-container')
    const next = teaser.querySelector('.button-next')
    const prev = teaser.querySelector('.button-prev')

    const teaserSlider = new Swiper(slider, {
      speed: 800,
      slidesPerView: 1,
      slidesPerGroup: 1,
      navigation: {
        nextEl: next,
        prevEl: prev
      },
      watchOverflow: true,
      breakpoints: {
        998: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      },
      allowTouchMove: false
    })
    teaserSlider.init()
  })
})
